import { DismissablePromptKey } from '@ms/yammer-data/dist/state/types';
import { useLoadDismissablePrompts, useShouldStartDismissablePrompt } from '@ms/yammer-hooks/dist/dismissablePrompts';
import { useIsVivaEngageRebranding } from '@ms/yammer-hooks/dist/rebranding';

const promptKey = DismissablePromptKey.VivaEngageRebrandingDialog;

type UseShouldShowRebrandingDialog = () => boolean;
export const useShouldShowRebrandingDialog: UseShouldShowRebrandingDialog = () => {
  useLoadDismissablePrompts({ promptKeys: [promptKey] });
  const isVivaEngageRebranding = useIsVivaEngageRebranding();
  const shouldStartRebrandingDialog = useShouldStartDismissablePrompt(promptKey);

  return isVivaEngageRebranding && shouldStartRebrandingDialog;
};

type UseGetRebrandingDialogPromptKey = () => DismissablePromptKey;
export const useGetRebrandingDialogPromptKey: UseGetRebrandingDialogPromptKey = () => promptKey;
